import { useCallback, useState } from 'react';
import { useLazyGetBedRotationCheckQuery } from '../../../../../api/fieldsApi';
import type { RotationCheckResult } from '../../../../../api/fieldsApi';

export const useRotationCheck = () => {
  const [rotationCheck, setRotationCheck] = useState<RotationCheckResult | null>(null);
  const [triggerRotationCheck] = useLazyGetBedRotationCheckQuery();

  const runRotationCheck = useCallback(
    async (cropId: string | undefined, bedId: string | undefined) => {
      if (!cropId || !bedId) {
        setRotationCheck(null);
        return;
      }
      try {
        const result = await triggerRotationCheck({
          bedId: String(bedId),
          cropId: String(cropId),
        }).unwrap();
        setRotationCheck(result);
      } catch {
        setRotationCheck(null);
      }
    },
    [triggerRotationCheck],
  );

  const resetRotationCheck = useCallback(() => setRotationCheck(null), []);

  return { rotationCheck, runRotationCheck, resetRotationCheck };
};
